import { html, el } from '../html.js';
import { screen } from '../shell.js';
import { api } from '../api.js';
import { state } from '../state.js';
import { go } from '../router.js';

// The username-and-password form of the three signed-out screens.
function credentials({ heading, sentence = '', button, autocomplete }, submit) {
  const s = screen({ bars: false });
  const form = el(html`<form class="stack" novalidate>
    <h1>${heading}</h1>
    ${sentence ? html`<p>${sentence}</p>` : ''}
    <label class="field"><span>Username</span>
      <input name="username" autocomplete="username" autocapitalize="none" spellcheck="false" required minlength="2" maxlength="30"></label>
    <label class="field"><span>Password</span>
      <input name="password" type="password" autocomplete="${autocomplete}" required minlength="8" maxlength="200"></label>
    <p class="error" role="alert" hidden></p>
    <button class="primary" type="submit">${button}</button>
  </form>`);
  s.body.append(form);
  const problem = form.querySelector('.error');
  const btn = form.querySelector('button');
  form.addEventListener('submit', async e => {
    e.preventDefault();
    btn.disabled = true;
    problem.hidden = true;
    try {
      await submit({ username: form.elements.username.value, password: form.elements.password.value });
    } catch (x) {
      problem.textContent = x.message;
      problem.hidden = false;
      btn.disabled = false;
    }
  });
  return s.el;
}

export const setupView = () => credentials({
  heading: 'Set up Shteker',
  sentence: 'You are the first one here. Pick a username and a password to become the owner.',
  button: 'Create account',
  autocomplete: 'new-password',
}, async creds => {
  state.user = (await api('POST', '/api/setup', creds)).user;
  state.needsSetup = false;
  go('/', 'Account created.');
});

export const signInView = () => credentials({ heading: 'Sign in', button: 'Sign in', autocomplete: 'current-password' }, async creds => {
  state.user = (await api('POST', '/api/login', creds)).user;
  go(location.pathname + location.search);
});

export async function joinView({ token }) {
  try {
    await api('GET', `/api/invites/${encodeURIComponent(token)}`);
  } catch (x) {
    const s = screen({ bars: false });
    s.body.append(el(html`<div class="stack"><h1>Join Shteker</h1><p>${x.message}</p></div>`));
    return s.el;
  }
  return credentials({ heading: 'Join Shteker', sentence: 'Pick a username and a password.', button: 'Join', autocomplete: 'new-password' }, async creds => {
    state.user = (await api('POST', '/api/join', { token, ...creds })).user;
    go('/', 'Joined.');
  });
}
